{
  "progress": {
    "done": "Completado",
    "step": "Paso {{current}} de {{total}}"
  },
  "intro": {
    "tag": "Tu opinión importa",
    "defaultDescription": "Responde unas preguntas rápidas y ayúdanos a mejorar tu experiencia.",
    "questions_one": "{{count}} pregunta",
    "questions_zero": "{{count}} preguntas",
    "questions_other": "{{count}} preguntas",
    "duration": "~{{minutes}} min",
    "start": "Empezar ahora",
    "later": "Responder más tarde"
  },
  "navigation": {
    "previous": "Anterior",
    "submit": "Enviar respuesta",
    "next": "Siguiente"
  },
  "done": {
    "title": "¡Gracias!",
    "description": "Tu respuesta se ha enviado correctamente",
    "xpEarned": "+{{xp}} XP conseguidos"
  },
  "input": {
    "selectPlaceholder": "Selecciona",
    "npsLow": "Nada probable",
    "npsHigh": "Muy probable"
  },
  "toast": {
    "created": "¡Encuesta creada!",
    "createError": "Error al crear la encuesta",
    "updated": "¡Encuesta actualizada!",
    "updateError": "Error al actualizar la encuesta",
    "deleted": "Encuesta eliminada",
    "deleteError": "Error al eliminar",
    "duplicated": "¡Encuesta duplicada!",
    "duplicateError": "Error al duplicar",
    "responseSent": "¡Respuesta enviada correctamente!",
    "responseError": "Error al enviar la respuesta"
  }
}
